import { z } from "zod";

export const METER_IMPORT_TYPES = ["ZW", "CW", "CO", "E"] as const;

export const meterImportRowSchema = z
	.object({
		serial_number: z.string().trim().min(1, "required").max(32, "max_length"),
		encryption_key: z.string().trim().optional().default(""),
		type: z.enum(METER_IMPORT_TYPES, { message: "invalid_type" }),
		street: z.string().trim().optional().default(""),
		apartment_number: z.string().trim().optional().default(""),
	})
	.refine(
		(r) => {
			const hasStreet = r.street.length > 0;
			const hasApt = r.apartment_number.length > 0;
			return hasStreet === hasApt;
		},
		{ message: "address_partial", path: ["street"] },
	);

export type MeterImportRowValidated = z.infer<typeof meterImportRowSchema>;

export type MeterImportRowErrors = Partial<
	Record<
		"serial_number" | "encryption_key" | "type" | "street" | "apartment_number",
		string
	>
>;

export function validateMeterImportRow(row: {
	serial_number: string;
	encryption_key: string;
	type: string;
	street: string;
	apartment_number: string;
}): MeterImportRowErrors {
	const result = meterImportRowSchema.safeParse(row);
	if (result.success) return {};
	const errors: MeterImportRowErrors = {};
	for (const issue of result.error.issues) {
		const key = issue.path[0] as keyof MeterImportRowErrors | undefined;
		if (key && !errors[key]) errors[key] = issue.message;
	}
	return errors;
}
